import { AiOutlineNotification } from 'react-icons/ai'
import { BiMessageError } from 'react-icons/bi'
import {
  MdOutlineEmail,
  MdOutlineFactCheck,
  MdOutlineTableChart,
  MdManageAccounts
} from 'react-icons/md'
import { RiNotificationBadgeLine } from 'react-icons/ri'

import type { ILink } from '@base/@types/components/Layout/Navigator'

const alertLinks: ILink = {
  group: 'Alertas',
  icon: <BiMessageError />,
  roles: [
    'Diretor',
    'Logistica',
    'Parceiro',
    'Administrador',
    'GerenteCategoria',
    'AnalistaDistribuicao',
    'AnalistaPlanejamento',
    'AnalistaComercial',
    'AnalistaCompra',
    'GerenteLoja',
    'GerenteProduto',
    'Analista',
    'Assistente',
    'Loja'
  ],
  menu: [
    // {
    //   name: 'Compra',
    //   path: '/alertas/compra',
    //   icon: <RiNotificationBadgeLine />,
    //   description: 'Alerta de adiantamento de compra e recebimento de produto',
    //   roles: [
    //     'Diretor',
    //     'AnalistaCompra',
    //     'AnalistaDistribuicao',
    //     'Parceiro',
    //     'Administrador',
    //     'AnalistaPlanejamento',
    //     'GerenteProduto',
    //     'AnalistaComercial',
    //     'Analista',
    //     'Assistente'
    //   ]
    // },
    {
      name: 'Processamento Pedidos Compra',
      path: '/alertas/processamento-compra',
      icon: <RiNotificationBadgeLine />,
      description: 'Alertas e processamento de pedidos de compra',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',
        'GerenteProduto',
        'AnalistaComercial',
        'Analista',
        'Assistente'
      ]
    },
    {
      name: 'Follow Up Compras',
      path: '/alertas/follow-up',
      icon: <AiOutlineNotification />,
      description: 'Acompanhamento da carteira de pedidos em aberto ',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',
        'GerenteProduto',
        'AnalistaComercial',
        'Analista',
        'Assistente',
        'GerenteLoja',
        'Loja'
      ]
    },
    {
      name: 'Follow Up Reab',
      path: '/alertas/follow-up-reab',
      icon: <AiOutlineNotification />,
      description:
        'Acompanhamento da carteira de pedidos em aberto de Reabastecimento ',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Logistica',
        'Administrador',
        'AnalistaPlanejamento',
        'GerenteProduto',
        'AnalistaComercial',
        'Analista',
        'Assistente',
        'GerenteLoja',
        'Loja'
      ]
    },
    {
      name: 'Cronograma Semanal de Compras',
      path: '/dashboard/cronograma-semanal',
      icon: <AiOutlineNotification />,
      description:
        'Acompanhamento semanal do cronograma de compras por fornecedor, loja e categoria',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'Administrador',
        'AnalistaPlanejamento',
        'GerenteCategoria',
        'GerenteProduto',
        'Analista'
      ]
    },
    {
      name: 'Follow Up Fornecedor',
      path: '/follow-up-fornecedor',
      icon: <MdOutlineTableChart />,
      description:
        'Painel geral de disparos e status de confirmação de pedidos com fornecedores',
      roles: ['Administrador', 'AnalistaCompra', 'AnalistaPlanejamento'],
      companies: [1000]
    },
    {
      name: 'Follow Up Fornecedor — Aprovação',
      path: '/follow-up-fornecedor/aprovacao',
      icon: <MdOutlineFactCheck />,
      description:
        'Aprovação em lote das respostas enviadas pelos fornecedores',
      roles: ['Administrador', 'AnalistaCompra', 'AnalistaPlanejamento'],
      companies: [1000]
    },
    {
      name: 'Follow Up Fornecedor — Configurações',
      path: '/follow-up-fornecedor/configuracoes',
      icon: <MdOutlineEmail />,
      description: 'Cadastro de e-mails de fornecedores para disparo semanal',
      roles: ['Administrador', 'AnalistaCompra', 'AnalistaPlanejamento'],
      companies: [1000]
    },
    {
      name: 'Follow Up Fornecedor — Config. Compradores',
      path: '/follow-up-fornecedor/config-compradores',
      icon: <MdManageAccounts />,
      description:
        'Vínculo de usuários responsáveis pela aprovação por fornecedor e categoria',
      roles: ['Administrador', 'AnalistaCompra', 'AnalistaPlanejamento'],
      companies: [1000]
    }
  ]
}

export default alertLinks
